/**
 * @module base/toolkit/1^0
 * @author 
 * @version 1.0
 * @description 工具类组件：常用数组、对象操作方法、字符串转义等方法
 */
let Toolkit = {

    // 去掉字符串第一个符号，比如query string去掉第一个不需要的？
    sliceFirstChar: function (string) {
        let len = string.length

        return string.slice(1, len)
    },

    /**
     * @function getTypeString
     * @param {string} val - 变量，可为任意值
     * @author 
     * @description  获取变量类型
     * @instance
     * @return {String} val
     * @example
     * M_TOOLKIT.getTypeString(function(){}); //function
    */
    getTypeString: function (val) {
        return Object.prototype.toString.call(val)
    },
    
    /**
     * @function isWindow
     * @param {object} obj - 对象
     * @author 
     * @description  是否为window对象
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.isWindow({}); //false
    */
    isWindow: function ( obj ) {
        return obj != null && obj == obj.window
    },

    /**
     * @function isEmptyObject
     * @param {object} params - 对象
     * @author 
     * @description  是否空对象
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.isEmptyObject({}); //true
    */
    isEmptyObject: function (params) {
        return params && Object.keys(params).length === 0
    },
    /**
     * @function isEmptyValueObject
     * @param {object} params - 对象
     * @author 
     * @description  是否对象的每个键值都为空
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.isEmptyValueObject({name: ''}); //true
    */
    isEmptyValueObject: function (params) {
        return params && Object.values(params).every(i => !i)
    },
    
    /**
     * @function isObject
     * @param {object} val - 任意值
     * @author 
     * @description  是否为对象（不包括数组）
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.isObject({}); //true
    */
    isObject: function (val) {
        return this.getTypeString(val).indexOf('Object') > -1
    },
   
    /**
     * @function isFunction
     * @param {object} value - 任意值
     * @author 
     * @description  是否为函数
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.isFunction({}); //true
    */
    isFunction: function (value) {
        return typeof (value) == 'function'
    },

    /**
     * @function isPlainObject
     * @param {object} obj - 任意值
     * @author 
     * @description  是否是一个纯粹的对象；所谓"纯粹的对象"，就是该对象是通过"{}"或"new Object"创建的。
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.isPlainObject({}); //true
    */
    isPlainObject: function (obj) {
        return this.isObject(obj) && !this.isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype
    },

    /**
     * @function trim
     * @param {string} str - 对象
     * @author 
     * @description  去除空格
     * @instance
     * @return {String} str
     * @example
     * M_TOOLKIT.trim({}); //true
    */
    trim: function (str) {
        return str && typeof str === 'string' ? str.replace(/\s/g, '') : ''
    },    

    /**
     * @function validateNumber
     * @param {string} val - 字符串
     * @author 
     * @description  校验是否数字
     * @instance
     * @return {Boolean} true
     * @example
     * M_TOOLKIT.validateNumber('123a'); //false
    */
    validateNumber: function (val) {
        return /^[0-9]*$/.test(val)
    },

    /**
     * @function extend
     * @param {object} ele - 页面元素
     * @author 
     * @description  重构页面元素内部的属性，兼容WEB获取元素属性方法不一样的（重写jquery的extend的方法）
     * @instance
     * @return {object} ele
     * @example
     * M_TOOLKIT.extend(true, {}, {}); //第一个参数若为bool值代表是否是深拷贝，默认不是深拷贝
    */
    extend: function () {
        var src = null, // 缓存被合并的属性（未做处理）
            clone = null, // 缓存被合并的属性（兼容处理）
            copyIsArray = null, // 当前属性是否是数组
            copy = null, // 缓存被复制的属性
            name = '', // key值
            options = {}, // 缓存被复制的入参
            target = arguments[0] || {},
            i = 1, // 入参下标
            length = arguments.length,
            deep = false

        // 处理深拷贝场景
        if ( typeof target === 'boolean' ) {
            deep = target
            target = arguments[1] || {}
            // 如果第一个参数是bool类型，忽略第一个参数，直接取第二个参数
            i = 2
        }

        // 处理深拷贝场景里面的入参可能不是对象
        if ( typeof target !== 'object' && !Toolkit.isFunction(target) ) {
            target = {}
        }

        for ( ; i < length; i++ ) {
            // 仅处理非null或undefined
            if ((options = arguments[ i ]) != null ) {
                // 拷贝后一个对象到前面的对象
                for ( name in options ) {
                    src = target[ name ] // 判断当前key值是否一样
                    copy = options[ name ]

                    // 如果对应的值一样看下一个参数
                    if ( target === copy ) {
                        continue
                    }

                    // 如果当前合并的是对象或数组 需要递归调用
                    if ( deep && copy && ( Toolkit.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)) ) ) {
                        if ( copyIsArray ) {
                            copyIsArray = false
                            clone = src && Array.isArray(src) ? src : []

                        } else {
                            clone = src && Toolkit.isPlainObject(src) ? src : {}
                        }

                        // 递归调用
                        target[ name ] = Toolkit.extend( deep, clone, copy )

                    // 当copy不是对象且不是undefined则结束递归开始赋值
                    } else if ( copy !== undefined ) {
                        target[ name ] = copy
                    }
                }
            }
        }

        // 返回合并后的对象
        return target
    },

    /**
     * @function rebuildAttr
     * @param {object} e - 页面元素
     * @author 
     * @description  重构页面元素内部的属性，兼容WEB获取元素属性方法不一样的
     * @instance
     * @return {object} ele
     * @example
     * M_TOOLKIT.rebuildAttr(e); //true
    */
    rebuildAttr: function (e) {
        let ele = e.currentTarget || e.target, // H5：currentTarget Native:target
            dataset = ele.dataset, // H5 data属性存放在dataset里面
            native_attr = {}

        // 如果有dataset,则按照native模式赋值
        if ( dataset ){
            for ( let key in dataset ) {
                let new_key = key[0].toUpperCase() + key.substring(1) // 首字母转大写

                native_attr['data' + new_key] = dataset[key]
            }
            e.target.attr = native_attr
        }

        return e
    },

    /**
     * @function cleanUselessAttr
     * @param {object} obj - 清除对象
     * @author Vincwu <vincewu@lexin.com>
     * @description  清楚对象中的空属性
     * @instance
     * @return {object} 
     * @example
     * M_TOOLKIT.cleanUselessAttr({}); //{}
    */
    cleanUselessAttr: function (obj) {
        let return_obj = {}

        // 遍历对象的属性
        if (this.isPlainObject(obj)) {

            // 合并属性
            Object.assign(return_obj, obj)

            for (let i in return_obj) {
                if (return_obj[i] == '' || (this.isObject(return_obj[i]) && this.isEmptyObject(return_obj[i]))){
                    delete return_obj[i]
                }
            }
        }

        return return_obj
    },
    
    /**
     * 获取当前时间
     * time 时间戳 int
     */
    getTime () {
        let time = new Date().getTime()

        return time
    },

    // 版本号对比
    compareVersion: function (ver_a, ver_b) {
        // 若传入的值无效，返回false，相等返回0
        if (ver_a && ver_b) {
            let arr_a = ver_a.split('.'),
                arr_b = ver_b.split('.')

            for (let i = 0, len = Math.max(arr_a.length, arr_b.length); i < len; i++) {
                let diff = parseInt((arr_a[i] || 0), 10) - parseInt((arr_b[i] || 0), 10)

                if (diff > 0) {
                    return 1
                } else if (diff < 0) {
                    return -1
                }
            }
            return 0
        } else {
            return false
        }
    },

    /**
     * 过滤对象中的空值
     * @param {Object} obj 过滤对象
     * @return {Object} 
     */
    filterNullData (obj = {}){
        let res = {}
        for (const k in obj) {
            if (obj[k] !== '' && obj[k] !== null && obj[k] !== undefined ) {
                res[k] = obj[k]
            }
        }
        return res
    }
}

export default Toolkit